import styled from "styled-components";

export const ModalHeader = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;

	svg {
		flex-shrink: 0;
		width: 20px;
		height: 20px;
		padding: 8px;
		box-sizing: content-box;
		border-radius: 8px;
		background: #fff4e5;
		color: #e8590c;
	}

	h1 {
		font-size: 18px;
		font-weight: 700;
		color: #31475a;
		margin: 0 0 8px;
	}

	p {
		font-size: 14px;
		color: #667684;
		margin: 0;
	}
`;

export const ContractInfoCard = styled.div`
	margin-top: 16px;
	padding: 12px 16px;
	background: #f7f8fa;
	border-radius: 8px;

	strong {
		display: block;
		font-size: 14px;
		color: #31475a;
	}

	span {
		font-size: 13px;
		color: #667684;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 24px;

	button:first-child {
		background: transparent;
		border: 1px solid #d0d5dd;
		color: #31475a;
	}

	button:last-child {
		background: #e8590c;
		border: 1px solid #e8590c;
		color: #fff;
	}

	button {
		border-radius: 8px;
		padding: 8px 24px;
		font-size: 14px;
		font-weight: 700;
		cursor: pointer;

		&:disabled {
			background: #f2f4f7;
			border: 1px solid #f2f4f7;
			color: #dddddd;
			cursor: not-allowed;
		}
	}
`;
